import React from "react";
import axios from "axios";
import { Api_Url } from "../../../../utils/ApiUrl";
import { useState, useEffect } from "react";
import { is } from "date-fns/locale";

const Bottompage = ({
  setRoutes,
  basicInfo,
  setLoader,
  projectSetup,
  teamFormData,
  walletformData,
  socialsFormData,
  currentStep,
  saleRounds,
  nftFormData,
  projectId,
  setLastUpdated,
  lastUpdated,
  isLive,
  isPreview,
  setId,
  setChangeRoute,
  setProjectId,
  isAvailable,
}) => {
  const SaveDraft = async () => {
    let token = localStorage.getItem("accessToken");
    setLoader(true);
    const hasProjectDocuments =
      Array.isArray(projectSetup?.documents?.value) &&
      projectSetup.documents.value.some((doc) => doc.file);
    let localProjectSetup = undefined;

    if (hasProjectDocuments) {
      localProjectSetup = {
        ...projectSetup,
        // transform documents
        documents: {
          ...projectSetup.documents,
          value: projectSetup.documents.value.map(
            ({ name, file2, file, ...rest }) => ({
              ...rest,
              title: rest.title || name || "",
              url: file || null, // convert file to url
              // file2 is removed automatically
            })
          ),
        },
        // transform projectMedia to array of objects with title and url
        projectMedia: {
          ...projectSetup.projectMedia,
          value: projectSetup.projectMedia.value
            .filter((item) => item.url) // Only include successfully uploaded items
            .map(({ title, url }) => ({ title, url })), // 👈 Keep both title and url
        },
      };
    }
    let localTeamData = "";

    // Check if there are valid team members
    const hasValidTeamMembers = teamFormData.team.some(
      (member) =>
        member.name.trim() !== "" ||
        member.designation.trim() !== "" ||
        member.bio.trim() !== "" ||
        member.image !== null
    );

    if (hasValidTeamMembers) {
      localTeamData = {
        team: teamFormData.team
          .filter(
            (member) =>
              member.name.trim() !== "" ||
              member.designation.trim() !== "" ||
              member.bio.trim() !== "" ||
              member.image !== null
          )
          .map(({ image, name, designation, bio, ...rest }) => {
            const teamMember = {
              ...rest,
              Name: name, // Transform to capital N
              designation,
              bio,
            };

            // Only add image if it's not null
            if (image !== null) {
              teamMember.image = image;
            }

            return teamMember;
          }),
      };
    }

    let saleRoundsPayload = undefined;

    // Only create if we have rounds and all are valid
    if (saleRounds.length > 0) {
      const allValid = saleRounds.every(
        (round) =>
          round.roundNumber > 0 &&
          round.roundPrice &&
          parseFloat(round.roundPrice) > 0 &&
          round.startDate &&
          round.startDate.trim() !== "" &&
          round.enddate &&
          round.enddate.trim() !== "" &&
          new Date(round.enddate) > new Date(round.startDate)
      );

      if (allValid) {
        saleRoundsPayload = saleRounds.map(
          ({ roundNumber, roundPrice, startDate, enddate }) => ({
            roundNumber,
            roundPrice: parseFloat(roundPrice),
            startDate,
            enddate: enddate,
          })
        );
      }
    }

    let localNftDetails = undefined;

    if (nftFormData.nftRequired) {
      // Check if all NFT details are complete
      const allNftDetailsComplete = nftFormData.nftDetails.every(
        (nft) =>
          nft.image &&
          nft.price &&
          nft.price.toString().trim() !== "" &&
          !isNaN(parseFloat(nft.price)) &&
          parseFloat(nft.price) > 0
      );

      // Only set localNftDetails if all details are complete
      if (allNftDetailsComplete && nftFormData.nftDetails.length > 0) {
        localNftDetails = {
          nftRequired: true,
          nftDetails: nftFormData.nftDetails.map((nft) => ({
            image: nft.image,
            price: parseFloat(nft.price),
          })),
        };
      }
      // If incomplete, localNftDetails remains undefined
    } else {
      // If nftRequired is false, include it in the payload
      localNftDetails = {
        nftRequired: false,
        nftDetails: [],
      };
    }

    let data = JSON.stringify({
      projectName:
        basicInfo?.projectName?.value !== ""
          ? basicInfo?.projectName?.value
          : undefined,
      projectTicker:
        basicInfo?.projectTicker?.value !== "" && isAvailable
          ? basicInfo?.projectTicker?.value
          : undefined,
      projectShortDescription:
        basicInfo?.shortDescription?.value !== ""
          ? basicInfo?.shortDescription?.value
          : undefined,
      projectDetails:
        basicInfo?.details?.value !== ""
          ? basicInfo?.details?.value
          : undefined,
      projectImage: projectSetup?.projectImage?.value
        ? projectSetup?.projectImage?.value
        : undefined,
      projectBannerDesktop: projectSetup?.projectBannerDesktop?.value
        ? projectSetup?.projectBannerDesktop?.value
        : undefined,
      projectBannerMobile: projectSetup?.projectBannerMobile?.value
        ? projectSetup?.projectBannerMobile?.value
        : undefined,
      tokenomicsChartDark: projectSetup?.tokenomicsChartDark?.value
        ? projectSetup?.tokenomicsChartDark?.value
        : "",
      tokenomicsChartLight: projectSetup?.tokenomicsChartLight?.value
        ? projectSetup?.tokenomicsChartLight?.value
        : undefined,
      youtubeEmbed: projectSetup?.youtubeEmbeds?.value?.some(
        (url) => url.trim() !== ""
      )
        ? projectSetup.youtubeEmbeds.value
        : undefined,
      projectMedia: localProjectSetup?.projectMedia?.value,
      projectDocument: hasProjectDocuments
        ? localProjectSetup?.documents?.value
        : undefined,
      team: localTeamData?.team ? localTeamData?.team : localTeamData,
      saleRounds: saleRoundsPayload,
      projectWebsite:
        socialsFormData?.projectWebsite !== ""
          ? socialsFormData?.projectWebsite
          : undefined,
      projectTwitter:
        socialsFormData?.projectTwitter !== ""
          ? socialsFormData?.projectTwitter
          : undefined,
      projectTelegram:
        socialsFormData?.projectTelegram !== ""
          ? socialsFormData?.projectTelegram
          : undefined,
      projectMedium:
        socialsFormData?.projectMedium !== ""
          ? socialsFormData?.projectMedium
          : undefined,
      projectYoutube:
        socialsFormData?.projectYoutube !== ""
          ? socialsFormData?.projectYoutube
          : undefined,
      projectDiscord:
        socialsFormData?.projectDiscord !== ""
          ? socialsFormData?.projectDiscord
          : undefined,
      projectLinkedIn:
        socialsFormData?.projectLinkedIn !== ""
          ? socialsFormData?.projectLinkedIn
          : undefined,
      projectFundWallet:
        walletformData?.projectFundWallet !== ""
          ? walletformData?.projectFundWallet
          : undefined,
      platformFeeWallet:
        walletformData?.platformFeeWallet !== ""
          ? walletformData?.platformFeeWallet
          : undefined,
      ownerWallet:
        walletformData?.ownerWallet !== ""
          ? walletformData?.ownerWallet
          : undefined,
      buyBackBurnWallett:
        walletformData?.buybackBurnWallet !== ""
          ? walletformData?.buybackBurnWallet
          : undefined,
      allowedTokens:
        walletformData?.acceptedPaymentTokens?.length > 0
          ? walletformData?.acceptedPaymentTokens
          : undefined,
      platformFeeThreshold:
        walletformData?.platformFeeThreshold !== ""
          ? walletformData?.platformFeeThreshold
          : undefined,
      initialPlatformAmount:
        walletformData?.initialPlatformAmount !== ""
          ? walletformData?.initialPlatformAmount
          : undefined,
      nftRequired: localNftDetails?.nftRequired,
      buyBack: nftFormData?.buyBackRequired,
      nftDetails: localNftDetails?.nftDetails,
      stage: projectId && currentStep === 7 ? undefined : currentStep + 1,
      id: projectId ? projectId : undefined,
    });

    console.log("projectIdprojectId", projectId);
    console.log("nftFormData", localNftDetails);
    localStorage?.removeItem("draftProjectId");

    let config = {
      method: projectId ? "patch" : "post",
      maxBodyLength: Infinity,
      url: `${Api_Url}/pro-projects/${projectId ? "update" : "create"}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("respspspspspsp", response.data?.data?.updatedAt);
        // setRoutes(false);
        setProjectId(response.data?.data?._id);
        setLastUpdated(response.data?.data?.updatedAt);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  // Helper function to collect all media URLs
  const collectAllMediaUrls = () => {
    const urls = [];

    // Helper to safely add URL
    const addUrl = (url) => {
      if (
        url &&
        typeof url === "string" &&
        url.startsWith("https://dh3bzuu7a45gi.cloudfront.net/")
      ) {
        urls.push(url);
      }
    };

    // Project Setup - single values
    addUrl(projectSetup.projectImage.value);
    addUrl(projectSetup.projectBannerDesktop.value);
    addUrl(projectSetup.projectBannerMobile.value);
    addUrl(projectSetup.tokenomicsChartDark.value);
    addUrl(projectSetup.tokenomicsChartLight.value);

    // Project Media - array of objects with url property
    projectSetup.projectMedia.value?.forEach((item) => addUrl(item.url)); // 👈 Updated

    // Documents - array with file property
    projectSetup.documents.value?.forEach((doc) => addUrl(doc.file));

    // Team - array with image property
    teamFormData.team?.forEach((member) => addUrl(member.image));

    // NFT Details - array with image property
    nftFormData.nftDetails?.forEach((nft) => addUrl(nft.image));

    // BuyBack Details - array with image property
    nftFormData.buyBackDetails?.forEach((buyback) => addUrl(buyback.image));

    // Remove duplicates
    return [...new Set(urls)];
  };

  // Discard project function
  const discardProject = async (id) => {
    try {
      // Collect all media URLs
      setLoader(true);
      const mediaUrls = collectAllMediaUrls();

      console.log("URLs to delete:", mediaUrls);

      // If there are no URLs, just return

      const token = localStorage.getItem("accessToken");

      // Delete all media from server
      if (mediaUrls?.length > 0) {
        const deleteResponse = await axios.delete(`${Api_Url}/uploads/`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: JSON.stringify({
            url: mediaUrls,
          }),
        });
      }

      if (id !== "noid") {
        let config = {
          method: "delete",
          maxBodyLength: Infinity,
          url: `${Api_Url}/pro-projects/${projectId}/delete`,
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${token}`,
          },
        };

        axios
          .request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
          })
          .catch((error) => {
            console.log(error);
          });
      }
      setTimeout(() => {
        setRoutes(false);
        setId(null);
      }, [3000]);
    } catch (error) {
      console.error("Error deleting media:", error);
      throw error;
    }
  };

  const [timeAgo, setTimeAgo] = useState("");
  const getTimeAgo = (timestamp) => {
    if (!timestamp) return "";

    const now = new Date();
    const past = new Date(timestamp);
    const diffInSeconds = Math.floor((now - past) / 1000);

    // Less than a minute
    if (diffInSeconds < 60) {
      return "just now";
    }

    // Minutes
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} min ago`;
    }

    // Hours
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    }

    // Days
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    }

    // Weeks
    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) {
      return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""} ago`;
    }

    // Months
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} month${diffInMonths > 1 ? "s" : ""} ago`;
    }

    // Years
    const diffInYears = Math.floor(diffInDays / 365);
    return `${diffInYears} year${diffInYears > 1 ? "s" : ""} ago`;
  };

  // Update time ago every minute
  useEffect(() => {
    const updateTimeAgo = () => {
      if (lastUpdated) {
        setTimeAgo(getTimeAgo(lastUpdated));
      }
    };

    updateTimeAgo(); // Initial update
    const interval = setInterval(updateTimeAgo, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [lastUpdated]);

  const updateRoutes = () => {
    if (setId) {
      setId(null);
    }
    localStorage?.removeItem("draftProjectId");
    setRoutes(false);
  };

  const updateRoutes2 = () => {
    console.log("isPreview");
    if (isPreview && !isLive) {
      setChangeRoute(false);
    } else {
      if (setId) {
        setId(null);
      }
      setRoutes(false);
    }
  };

  return (
    <>
      <div className="footter_main">
        <div className="custom-container">
          <section className="innner_foooter">
            <div className="twosbutton">
              {isLive ? null : (
                <button
                  onClick={() => {
                    discardProject();
                  }}
                  className="discard"
                >
                  Discard & Exit
                </button>
              )}
              {isPreview || currentStep === 0 ? (
                <button
                  onClick={() => updateRoutes2()}
                  className="backbuttonss"
                >
                  Back
                </button>
              ) : (
                <></>
              )}
            </div>

            <div className="lower_footer">
              {projectId || lastUpdated ? <h4>Last save: {timeAgo}</h4> : <></>}
              <button onClick={() => SaveDraft()} className="savebutton">
                Save Draft
              </button>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Bottompage;
